import { Heart, ShieldAlert } from "lucide-react";

const STRESSED_IMG = "https://images.unsplash.com/photo-1758520144705-b39e11ff32e3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxzdHJlc3NlZCUyMGJ1c2luZXNzJTIwcGVyc29uJTIwY29tcHV0ZXIlMjBwcm9ibGVtJTIwb2ZmaWNlfGVufDB8fHx8MTc3NjQ1MDkyMHww&ixlib=rb-4.1.0&q=75&w=960";

export default function RiskReversal() {
  return (
    <section
      id="risk-reversal"
      data-testid="risk-reversal-section"
      aria-label="Satisfaction guarantee - $100 charity donation if audit doesn’t find 3 actionable improvements"
      className="py-14 lg:py-12 bg-transparent"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          {/* Image - emotional trigger */}
          <div className="animate-fade-in-up">
            <div className="relative overflow-hidden border border-[#FF5722]/20">
              <img
                data-testid="risk-image"
                src={STRESSED_IMG}
                alt="Business professional stressed after discovering a cybersecurity breach"
                className="w-full h-auto object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#112240] via-[#112240]/30 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="flex items-center gap-2 mb-2">
                  <ShieldAlert className="w-4 h-4 text-[#FF5722]" />
                  <p className="text-[#FF5722] text-xs uppercase tracking-wider font-semibold">Don’t let this be you</p>
                </div>
                <p className="text-white text-sm">The average breach costs 9 months of exposure and millions in damages. Prevention costs a fraction.</p>
              </div>
            </div>
          </div>

          {/* Guarantee card */}
          <div className="animate-fade-in-up stagger-1">
            <div className="grid-border-card p-10 relative">
              <img
                src="/images/logo-circle.webp"
                alt="Veracity Technologies"
                loading="lazy"
                className="w-14 h-14 object-contain absolute top-6 right-6 opacity-50 brightness-150 drop-shadow-[0_0_8px_rgba(0,119,179,0.3)]"
              />
              <div className="w-14 h-14 flex items-center justify-center bg-[#FF5722]/10 border border-[#FF5722]/30 mb-6">
                <Heart className="w-7 h-7 text-[#FF5722]" />
              </div>
              <h2
                data-testid="guarantee-heading"
                className="text-2xl sm:text-3xl font-bold tracking-tight text-white mb-4"
                style={{ fontFamily: "Outfit, sans-serif" }}
              >
                Our Commitment
              </h2>
              <p
                data-testid="guarantee-text"
                className="text-[#c0cfe0] text-base leading-relaxed"
              >
                If we don’t identify at least <span className="text-white font-semibold">three actionable improvements</span> to 
                your operations, we’ll donate <span className="text-[#0077B3] font-bold">$100</span> to your favorite industry charity. 
                That’s how confident we are in the value we deliver.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
